const time = 15; // Velocidade do autoPlay do carrossel de notícias em segundos
let isPause, tick, percentTime;
const players = [];
const progressBar = $('.news-feed__carousel__progress .progress');

function fixInvalidHotsiteTitle() {
  const invalidTitlePattern = /(^|\W)(null|undefined)(\W|$)/i;
  const invalidTitlePatternGlobal = /(^|\W)(null|undefined)(\W|$)/gi;
  const pageName = globalThis.g_LumisPageConfig?.name?.trim() ?? '';
  const hasValidPageName = pageName !== '' && !pageName.startsWith('${');
  const safeTitle = hasValidPageName ? pageName : 'Shoppings Aliansce';
  const currentTitle = document.title.trim();

  if (currentTitle === '' || invalidTitlePattern.test(currentTitle)) {
    document.title = safeTitle;
    return;
  }

  document.title = currentTitle.replaceAll(invalidTitlePatternGlobal, '$1' + safeTitle + '$3');
}

function startProgressbar() {
  resetProgressbar();
  percentTime = 0;
  isPause = false;
  tick = setInterval(interval, 10);
}

function interval() {
  if (!isPause) {
    percentTime += 1 / (time + 0.1);
    progressBar.css({
      width: percentTime + '%',
    });

    if (percentTime >= 100) {
      $('.news-feed__carousel > ul').slick('slickNext');
      startProgressbar();
    }
  }
}

function resetProgressbar() {
  progressBar.css({
    width: 0 + '%',
  });

  clearTimeout(tick);
}

function onYouTubeIframeAPIReadyFeed(idDiv, idVideo) {
  // eslint-disable-next-line no-new
  const newPlayer = new YT.Player(idDiv, {
    height: '360',
    width: '640',
    videoId: idVideo,
    events: {
      onStateChange: onPlayerStateChange,
    },
  });

  players.push(newPlayer); // Adiciona o novo player ao array
}

function stopVideo() {
  players.forEach(player => player.stopVideo()); // Pausa todos os vídeos
}

function onPlayerStateChange(event) {
  if (event.data === YT.PlayerState.PLAYING) {
    isPause = true;
    $('.news-feed__carousel .btn--pause').removeClass('btn--active');
    $('.news-feed__carousel .btn--play').addClass('btn--active');
  } else if (event.data === YT.PlayerState.PAUSED) {
    isPause = false;
    $('.news-feed__carousel .btn--pause').addClass('btn--active');
    $('.news-feed__carousel .btn--play').removeClass('btn--active');
  }
}

function resetPlayButton() {
  stopVideo();

  if ($('.news-feed__carousel .btn--play').is('.btn--active')) {
    $('.news-feed__carousel .btn--play').removeClass('btn--active');
    $('.news-feed__carousel .btn--pause').addClass('btn--active');
  }
}

function initCarouselNavigation() {
  $('.news-feed__carousel > ul .slick-prev, .news-feed__carousel > ul .slick-next').on(
    'click',
    () => {
      startProgressbar();
      resetPlayButton();
    }
  );
}

function initCarouselPause() {
  $('.news-feed__carousel .btn--pause').on('click', function () {
    if ($(this).is('.btn--active')) {
      $(this).removeClass('btn--active');
      $('.news-feed__carousel .btn--play').addClass('btn--active');
      isPause = true;
    }
  });
}

function initCarouselPlay() {
  $('.news-feed__carousel .btn--play').on('click', function () {
    if ($(this).is('.btn--active')) {
      $(this).removeClass('btn--active');
      $('.news-feed__carousel .btn--pause').addClass('btn--active');
      isPause = false;
    }
  });
}

function initCarouselDotsNavigation() {
  $('.news-feed__dots .dot').on('click', function () {
    const position = $(this).data('position');
    const index = $('.news-feed__carousel > ul')
      .find(`[data-slick-index="${position}"]`)
      .data('slick-index');

    setTimeout(() => {
      $('.news-feed__carousel > ul').slick('slickGoTo', index);
      startProgressbar();
    }, 100);

    resetPlayButton();
  });
}

function initCarouselFilterNavigation() {
  $('.news-feed__categories li a').on('click', function () {
    const filter = $(this).data('category');
    const index = $('.news-feed__carousel > ul')
      .find(`[data-category="${filter}"]:not(.slick-cloned)`)
      .data('slick-index');

    $('.news-feed__categories li a').not($(this)).find('img').removeClass('category-img--selected');
    $('.news-feed__categories li a')
      .not($(this))
      .find('span')
      .removeClass('category-text--selected');
    $(this).find('img').addClass('category-img--selected');
    $(this).find('span').addClass('category-text--selected');

    setTimeout(() => {
      $('.news-feed__carousel > ul').slick('slickGoTo', index);
      startProgressbar();
    }, 100);

    resetPlayButton();
  });
}

const categorySlides = $('.news-feed__categories li');

$('.news-feed__categories').slick({
  infinite: false,
  dots: false,
  slidesToScroll: 2,
  slidesToShow: Math.min(categorySlides.length, 4.5),
  autoplay: false,
  autoplaySpeed: 1000,
  arrows: false,
  mobileFirst: true,
  responsive: [
    {
      breakpoint: 1499,
      settings: {
        arrows: true,
        slidesToShow: 10,
        slidesToScroll: 10,
      },
    },
    {
      breakpoint: 1199,
      settings: {
        arrows: true,
        slidesToShow: 8,
        slidesToScroll: 8,
      },
    },
    {
      breakpoint: 970,
      settings: {
        arrows: true,
        slidesToShow: 6,
        slidesToScroll: 6,
      },
    },
    {
      breakpoint: 739,
      settings: {
        arrows: true,
        slidesToShow: 5,
        slidesToScroll: 5,
      },
    },
  ],
});

$(document).ready(() => {
  fixInvalidHotsiteTitle();
  startProgressbar();

  $('.news-feed__video > .video__container > div').each(function (index) {
    const idDiv = $(this).attr('id');
    const idVideo = $(this).attr('data-videoid');

    onYouTubeIframeAPIReadyFeed(idDiv, idVideo);
  });

  $('.news-feed__carousel > ul').slick({
    lazyLoad: 'ondemand',
    infinite: true,
    dots: false,
    slidesToScroll: 1,
    slidesToShow: 1,
    arrows: true,
    mobileFirst: true,
  });

  $('.news-feed__carousel > ul').on(
    'afterChange',
    function (event, slick, currentSlide, nextSlide) {
      const currentCategory = $(this).find('.slick-active').data('category');
      const currentPosition = $(this).find('.slick-active').data('slick-index');

      $('.news-feed__categories li a')
        .not($(`[data-category='${currentCategory}']`))
        .find('img')
        .removeClass('category-img--selected');
      $('.news-feed__categories li a')
        .not($(`[data-category='${currentCategory}']`))
        .find('span')
        .removeClass('category-text--selected');
      $(`.news-feed__categories li a[data-category='${currentCategory}']`)
        .find('img')
        .addClass('category-img--selected');
      $(`.news-feed__categories li a[data-category='${currentCategory}']`)
        .find('span')
        .addClass('category-text--selected');
      $('.news-feed__carousel__header')
        .find(`[data-category='${currentCategory}']`)
        .addClass('active-category')
        .find(`[data-position='${currentPosition}']`)
        .addClass('active-dot');
      $('.news-feed__carousel__header > div')
        .not(`[data-category='${currentCategory}']`)
        .removeClass('active-category');
      $('.news-feed__dots')
        .find('.dot')
        .not(`[data-position='${currentPosition}']`)
        .removeClass('active-dot');
      $('.news-feed__carousel__content')
        .find(`[data-category='${currentCategory}'][data-position='${currentPosition}']`)
        .addClass('active-category--text');
      $('.news-feed__carousel__text')
        .not(`[data-category='${currentCategory}'][data-position='${currentPosition}']`)
        .removeClass('active-category--text');
    }
  );

  const map = {};

  $('.news-feed__carousel > ul li').each((index, element) => {
    if (!$(element).is('.slick-cloned')) {
      const category = $(element).data('category');

      if (map[category] == null) {
        map[category] = true;

        let html =
          `<div` +
          `	data-category="${category}"` +
          `	class="carousel--active-category__container"` +
          `>` +
          `	<div class="carousel--active-category">`;

        $(`.news-feed__categories a[data-category|="${category}"]`).each(function () {
          html += `<img` + `	src="${$(this).find('img').attr('src')}"` + `	alt=""` + `/>`;
        });

        html += `</div>` + `<div class="news-feed__dots">`;

        $(`.news-feed__carousel > ul li[data-category|="${category}"]`).each(function () {
          if (!$(this).is('.slick-cloned')) {
            html +=
              `<button data-position="${$(this).data('slick-index')}"` + `class="dot"></button>`;
          }
        });

        html += `</div>` + `</div>` + `</div>`;

        $('.news-feed__carousel__header').append(html);

        $('.news-feed__carousel__header > div').first().addClass('active-category');

        $('.news-feed__carousel__header .news-feed__dots')
          .find('.dot:first-of-type')
          .addClass('active-dot');
      } else {
        $(this).remove();
      }
    }
  });

  initCarouselNavigation();
  initCarouselPause();
  initCarouselPlay();
  initCarouselDotsNavigation();
  initCarouselFilterNavigation();
});
